// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"e6ce5dc1","453":"871dcb79","897":"a9d811e8"}[chunkId] + ".chunk.js");